"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentSize = void 0;
const react_1 = require("react");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
function getSize(el) {
    if (!el) {
        return {
            width: 0,
            height: 0,
        };
    }
    const boundingRect = el.getBoundingClientRect();
    return {
        width: boundingRect.width,
        height: boundingRect.height,
    };
}
function useComponentSize(elemOrRef) {
    const el = elemOrRef &&
        (elemOrRef instanceof Element || elemOrRef instanceof HTMLDocument
            ? elemOrRef
            : elemOrRef.current);
    const [ComponentSize, setComponentSize] = react_1.useState(getSize(el));
    const handleResize = react_1.useCallback(function handleResize() {
        if (el) {
            setComponentSize(getSize(el));
        }
    }, [el]);
    react_1.useLayoutEffect(function () {
        if (!el) {
            return;
        }
        handleResize();
        const resizeObserver = new resize_observer_polyfill_1.default(function () {
            handleResize();
        });
        resizeObserver.observe(el);
        return function () {
            resizeObserver.disconnect();
        };
    }, [el, handleResize]);
    return ComponentSize;
}
exports.useComponentSize = useComponentSize;
//# sourceMappingURL=component-size.js.map